import global from "../global.js";
const log = global.log.getLogger("f_mtac.ui.InputAdminPasswordArea");
log.setLevel(log.levels.WARN);

/**
 * @brief create modal for input of admin password
 */
let InputAdminPasswordArea = function () {
    let {Modal} = window.f_mtac_theme;
    let input_admin_password_area_modal; // will contain the modal
    let $input_admin_password_area = document.getElementById("input_admin_password_area"); // fetch the HTML element

    /**
     *
     * @param {*} param0 title of the modal
     * @brief will initialize all HTML elements or clean them. Handlers will perform password validation
     * @returns authentification status, 1=admin, 0=failed
     */
    this.interact = function ({title = ""}) {
        input_admin_password_area_modal = new Modal($input_admin_password_area); // create modal with HTML
        let passphrase = null;
        let authentification_confirmation = 0; // resolve on this variable, initialize at 0 for fail

        // Prepare the modal
        $("#input_admin_password_area .modal-title").html(title);
        $("#input_admin_password_area input").val("").removeClass("is-invalid");

        // User actions handlers
        let handlers = {
            // Manage click on ok button
            ok: async () => {
                // Check input validity attributes
                if (!$("#input_admin_password_area input")[0].checkValidity()) {
                    $("#input_admin_password_area input").addClass("is-invalid");
                    $("#input_admin_password_area button[data-method='ok']").attr("disabled", true);
                }
                passphrase = $("#input_admin_password_area input").val();
                try {
                    // Send authentication request to the server
                    await global.server.administration.authenticate({passphrase});
                    authentification_confirmation = 1;
                    // Hide the modal and resole the promise
                    input_admin_password_area_modal.hide();
                } catch {
                    $("#input_admin_password_area input").addClass("is-invalid");
                }
            },
            // Manage click on cancel button
            cancel: () => {
                authentification_confirmation = 0;
                input_admin_password_area_modal.hide(); // hide the modal and resole the promise
            }
        };

        // Manage events
        // create listener and put focus on the modal
        $input_admin_password_area.addEventListener("shown.bs.modal", function () {
            $("#input_admin_password_area input").trigger("focus");
        });

        // register what button the user clicked on and call the corresponding handlers
        $("body").on("click.input_admin_password_area.btn", "#input_admin_password_area .btn", (event) => {
            let method = $(event.currentTarget).data("method");
            log.debug(`${method} pressed.`);
            handlers[method]();
        });

        $("#input_admin_password_area input").on("keyup paste", (event) => {
            if (event.key === "Enter") {
                return;
            }
            // Check input validity attributes
            if (!$("#input_admin_password_area input")[0].checkValidity()) {
                $("#input_admin_password_area input").addClass("is-invalid");
                $("#input_admin_password_area button[data-method='ok']").attr("disabled", true);
                return;
            }
            $("#input_admin_password_area input").removeClass("is-invalid");
            $("#input_admin_password_area button[data-method='ok']").removeAttr("disabled");
        });

        // when press enter, confirms the modal
        $("body").on("keydown", "#input_admin_password_area input", async (event) => {
            if (event.key === "Enter") {
                event.preventDefault();
                handlers["ok"]();
            }
        });

        // update the modal by removing old listeners and is waiting for the authentification_confirmation
        return new Promise((resolve) => {
            let interaction_end = () => {
                $input_admin_password_area.removeEventListener("shown.bs.modal", interaction_end);
                $input_admin_password_area.removeEventListener("hidden.bs.modal", interaction_end);
                $("body").off("click.input_admin_password_area.btn", "#input_admin_password_area .btn");
                $("body").off("keydown", "#input_admin_password_area input");
                $("#input_admin_password_area input").off("blur keyup paste");
                log.debug("Interaction ended with password:", passphrase);
                resolve(authentification_confirmation);
            };

            $input_admin_password_area.addEventListener("hidden.bs.modal", interaction_end); // end interaction when the modal is closed
            input_admin_password_area_modal.show();
        });
    };
};
export default new InputAdminPasswordArea();
